import { cn } from "@/lib/cn"

type LogoProps = {
  className?: string
  variant?: "default" | "mono-light" | "mono-dark"
}

type LogoMarkProps = {
  accentClassName?: string
  className?: string
}

export function LogoMark({ accentClassName = "fill-brand-500", className }: LogoMarkProps) {
  return (
    <svg viewBox="0 0 64 64" className={cn("h-[1.05em] w-[1.05em] shrink-0", className)} aria-hidden="true">
      <rect x="12" y="13" width="40" height="8" rx="4" className="fill-current" />
      <rect x="12" y="28" width="31" height="8" rx="4" className="fill-current" />
      <rect x="12" y="43" width="28" height="8" rx="4" className="fill-current" />
      <circle cx="47" cy="47" r="13" className={accentClassName} />
    </svg>
  )
}

export function Logo({ className, variant = "default" }: LogoProps) {
  const textColor =
    variant === "mono-light" ? "text-white" : "text-ink-950"
  const accentColor =
    variant === "mono-light" ? "fill-brand-400" : "fill-brand-500"

  return (
    <span
      className={cn(
        "inline-flex items-center gap-x-2 font-display text-2xl font-extrabold sm:text-3xl",
        textColor,
        className,
      )}
    >
      <LogoMark accentClassName={accentColor} />
      <span>CleanMyList</span>
    </span>
  )
}
